export enum ActionType {
  SET_FOOD_TRAY_TEMPLATE = 'SET_FOOD_TRAY_TEMPLATE',
  SET_FOOD_TRAY_TEMPLATE_PROP = 'SET_FOOD_TRAY_TEMPLATE_PROP',
  ADD_FOOD_LINE = 'ADD_FOOD_LINE',
  SET_FOOD_LINE_PROP = 'SET_FOOD_LINE_PROP',
  REMOVE_FOOD_LINE = 'REMOVE_FOOD_LINE',
  SET_FOOD_TRAYS_FOR_COLUMN = 'SET_FOOD_TRAYS_FOR_COLUMN',
  SET_FOOD_TRAY_PROP = 'SET_FOOD_TRAY_PROP',
  ADD_FOOD_TRAY_COLUMN = 'ADD_FOOD_TRAY_COLUMN',
  REMOVE_FOOD_TRAY_COLUMN = 'REMOVE_FOOD_TRAY_COLUMN',
  RESET_FOOD_TRAY_TEMPLATE = 'RESET_FOOD_TRAY_TEMPLATE',
}

export default ActionType;
